import * as paths from './staticPaths';

export const trialSeatLimit = 99;

export type Frequency = 'monthly' | 'annually';

export const frequencies: Array<{ value: Frequency; label: String }> = [
  { value: 'monthly', label: 'Monthly' },
  { value: 'annually', label: 'Annually' },
];

export const plans = [
  {
    name: 'Personal',
    id: 'tier-personal',
    cta: 'Start your free trial now',
    belowCta: 'No credit card required for trial.',
    href: paths.app,
    priceMonthlyCents: 799,
    priceAnnuallyMonthlyCents: 399,
    description:
      'Kickstart your seating charts with the Seating Chart Maker Personal Plan.',
    features: [
      'Unlimited seating charts',
      'Share resources via link',
      'Add participant photos',
      'Random and custom seating',
      'Wheel of names',
      'Email support',
    ],
    featured: true,
  },
  {
    name: 'Team',
    id: 'tier-team',
    cta: 'Contact us',
    href: paths.contact,
    priceAnnuallyMonthlyCents: 2500,
    description:
      'For professional users, teams and organizations. Includes up to 10 users.',
    features: [
      'Extra users $6/month/10 users',
      'Includes everything in Personal plan',
      'Share resources with your team',
      'Data integrations',
      'Priority support',
    ],
    featured: false,
  },
];

export type Plan = (typeof plans)[0];

/**
 * Returns no decimals if they are zero. Otherwise, returns two decimal places.
 * Returns a string with a dollar sign.
 */
export function centsToUSD(cents: number): string {
  const dollars = cents / 100;
  if (dollars % 1 === 0) {
    return `$${dollars}`;
  } else {
    return `$${dollars.toFixed(2)}`;
  }
}

export function savePercent(original: number, newPrice: number): string {
  const percent = ((original - newPrice) / original) * 100;
  return `${percent.toFixed(0)}%`;
}
